import "./navmenu.css";
export function Header() {
  return (
    // <nav className="navbar bg-dark bg-opacity-75 align-items-center d-flex  justify-content-between">
    //     <h1 class="navbar-brand">Мила Дудина</h1>

    //     <ul className="nav">
    //         <li className="nav-item">
    //             <a className="nav-link active" aria-current="page" href="#">
    //                 Портфолио
    //             </a>
    //         </li>
    //         <li className="nav-item">
    //             <a className="nav-link" href="#">
    //                 Тарифы
    //             </a>
    //         </li>
    //         <li className="nav-item">
    //             <a className="nav-link" href="#">
    //                 Обо мне
    //             </a>
    //         </li>
    //         <li className="nav-item">
    //             <a className="nav-link" href="#">
    //                 Контакты
    //             </a>
    //         </li>
    //     </ul>
    // </nav>

    <nav class="navbar header1 align-items-center d-flex  justify-content-between navbar-expand-lg ">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          Мила Дудина
        </a>

        <button
          class="navbar-toggler bg-light"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <a class="nav-link " aria-current="page" href="\">
                Главная
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link " aria-current="page" href="portfolio">
                Портфолио
              </a>
            </li>
            {/* <li class="nav-item">
              <a class="nav-link " aria-current="page" href="publication">
                Публикации
              </a>
            </li> */}
            <li class="nav-item">
              <a class="nav-link" href="awards">
                Награды и дипломы
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="feedback">
                Отзывы
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="contacts">
                Контакты
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
